import React from "react";
import withStyles from "components/common/wrappers/withStyles";

function Cross({ color, hasCrossContainer = true }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="23"
      height="22"
      viewBox="0 0 23 22"
    >
      <g
        fill="none"
        fillRule="evenodd"
        stroke="none"
        strokeWidth="1"
        transform="translate(-964 -296) translate(438 281) translate(525 13)"
      >
        {hasCrossContainer && (
          <rect
            width="22"
            height="22"
            x="1"
            y="1"
            fill="#bec7d3"
            stroke="#bec7d3"
            rx="0"
          />
        )}
        <path
          fill={color}
          fillRule="nonzero"
          d="M20.444 10.959l-6.994.033.032-6.66A.338.338 0 0013.134 4l-1.399.007c-.193 0-.35.15-.351.334l-.032 6.661-6.994.034c-.193.001-.35.151-.352.335L4 12.703c0 .184.155.332.348.332L11.342 13l-.032 6.66c-.001.185.155.333.348.332l1.399-.007c.193 0 .35-.15.351-.334l.032-6.661 6.994-.034c.194-.001.35-.15.352-.335l.006-1.332a.338.338 0 00-.348-.331z"
          transform="translate(0 1) rotate(45 12.396 11.997)"
        />
      </g>
    </svg>
  );
}

Cross.defaultProps = {
  color: "white"
};

export default withStyles(Cross);
